import { UseCaseSelectTrabajos } from '../../../Programados/TrabajosDE/Trabajos/Application/UseCaseSelectTrabajos'
import { RepositoryMain } from '../Domain/RepositoryMain'

export class UseCaseSelectTrabajosDE extends UseCaseSelectTrabajos<RepositoryMain> { }